import { useSelector } from 'react-redux'
import { useRef, useLayoutEffect, useEffect } from 'react'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { parseInTimezone } from '@calendly/datetime'
import styled from 'astroturf/react'
import { FixedContainer } from '@calendly/ui/components/fixed-container'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue700))'
const fontWeightBold = 'var(--fontWeightBold, 700)'
import { formatDate, formatTime } from '@calendly/booking-kit/services/time_format'

import { useI18n } from 'locales'
import { timeNotationSelector, timezoneSelector } from 'selectors'

import { InviteeCountButton } from './invitee_count_button'
import _Overlay from "invitee_list-Overlay.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_list.js?styleId=Overlay";
import _Container from "invitee_list-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_list.js?styleId=Container";
import _ButtonContainer from "invitee_list-ButtonContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_list.js?styleId=ButtonContainer";
import _Header from "invitee_list-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_list.js?styleId=Header";
import _InviteeNamesContainer from "invitee_list-InviteeNamesContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_list.js?styleId=InviteeNamesContainer";
import _InviteeName from "invitee_list-InviteeName.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_list.js?styleId=InviteeName";


const Overlay = /*#__PURE__*/styled(FixedContainer, null, {
  displayName: "Overlay",
  styles: _Overlay
})

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const ButtonContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
})

const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

const InviteeNamesContainer = /*#__PURE__*/styled('div', null, {
  displayName: "InviteeNamesContainer",
  styles: _InviteeNamesContainer
})

const InviteeName = /*#__PURE__*/styled('div', null, {
  displayName: "InviteeName",
  styles: _InviteeName
})

export const InviteeList = ({
  invitees,
  isSelected,
  startTime,
  toggleDropdown,
  onClick
}) => {
  const { i18n } = useI18n()
  const timeNotation = useSelector(timeNotationSelector)
  const timezone = useSelector(timezoneSelector)
  const parsedTime = parseInTimezone(startTime, timezone)
  const namesContainerRef = useRef()
  const isPhone = useDeviceType('isPhone')

  useLayoutEffect(() => {
    if (isPhone) {
      disableBodyScroll(namesContainerRef.current)
    }
  }, [isPhone])

  useEffect(() => () => clearAllBodyScrollLocks(), [])

  const dateTime = `${formatDate(parsedTime, i18n.t('time.formats.date_extra'))} - ${formatTime(parsedTime, timeNotation)}`

  return (
    <Container data-testid="invitee-vote-list">
      <Overlay onClick={toggleDropdown} />
      <Header>
        <div>{dateTime}</div>
        <ButtonContainer>
          <InviteeCountButton
            onClick={onClick}
            isSelected={isSelected}
            invitees={invitees}
            isFilled
          />
        </ButtonContainer>
      </Header>
      <InviteeNamesContainer ref={namesContainerRef}>
        {invitees.map((inv) => <InviteeName key={inv.full_name}>{inv.full_name}</InviteeName>)}
      </InviteeNamesContainer>
    </Container>
  )
}
